import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, formatDetail } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null=checking, false=not auth, object=auth
    const [error, setError] = useState("");

    useEffect(() => {
        let mounted = true;
        api.get("/auth/me")
            .then((r) => mounted && setUser(r.data))
            .catch(() => mounted && setUser(false));
        return () => {
            mounted = false;
        };
    }, []);

    async function login(email, password) {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.access_token) setAuthToken(data.access_token);
            setUser(data.user);
            return data.user;
        } catch (e) {
            const msg = formatDetail(e.response?.data?.detail) || e.message;
            setError(msg);
            throw new Error(msg);
        }
    }

    async function logout() {
        try {
            await api.post("/auth/logout");
        } catch (_) {}
        setAuthToken(null);
        setUser(false);
    }

    async function refreshMe() {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch (e) {
            return null;
        }
    }

    return (
        <AuthContext.Provider value={{ user, error, login, logout, refreshMe, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
